<nav class="navbar navbar-expand-lg fixed-top bg-white shadow-sm">
  <div class="container-fluid d-flex justify-content-between align-items-center px-3">
    <!-- Bloque Izquierda: Logo -->
    <ng-template #loadingTemplate>
    </ng-template>
    <!-- Bloque Centro: Links -->
    <div class="d-flex align-items-center col-md-12">
      <div class="profile d-flex">
        <img *ngIf="shopLogos?.large; else defaultImage" [src]="shopLogos.large" alt="User" class="profile-img"
          width="100" height="100" />
        <ng-template #defaultImage>
          <img src="../../../assets/icons/user.svg" alt="User" width="100" height="100" class="profile-img" />
        </ng-template>
      </div>
      <ul class="navbar-nav flex-row ">
        <div class="d-flex flex-row">
          <li class="nav-item px-1"
            *ngIf="permissions.analytics && themingService.shopTheming[0].shopSubscription.shopAnaliticsAccess">
            <a class="nav-link" routerLinkActive="active">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-bar-chart-2">
                <line x1="18" y1="20" x2="18" y2="10"></line>
                <line x1="12" y1="20" x2="12" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="14"></line>
              </svg>
              <app-analytics></app-analytics>
            </a>
          </li>
          <!-- Nuevo elemento para POS -->
          <li class="nav-item px-1" *ngIf="permissions.pos && themingService.shopTheming[0].shopSubscription.shopPosAccess">
            <a class="nav-link" routerLinkActive="active">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-shopping-bag">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 01-8 0"></path>
              </svg>
              <app-pos></app-pos>
            </a>
          </li>
          <li class="nav-item px-1" *ngIf="permissions.chatApp && themingService.shopTheming[0].shopSubscription.shopInfobipIntegrationAllow">
            <a class="nav-link" routerLinkActive="active">
              <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24">
                <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M12 21.25a9.25 9.25 0 1 0-8.307-5.177c.108.22.144.468.089.706l-.816 3.536a.6.6 0 0 0 .72.72l3.535-.817a1.06 1.06 0 0 1 .706.09A9.2 9.2 0 0 0 12 21.25M7.97 9.886h8.06m-8.06 4.228h5.748" />
              </svg>
              <app-chat-app></app-chat-app>
            </a>
          </li>
          <li class="nav-item px-4 pt-2" *ngIf="themingService.getShouldShowShopSelector()">
            <label>{{'YOURS_SHOPS' | translate}}</label>
            <div class="shop-select-container dropdown">
              <button class="shop-button btn dropdown-toggle d-flex align-items-center" type="button"
                id="shopDropdownButton" data-bs-toggle="dropdown" aria-expanded="false" [attr.title]="shopName">
                <img *ngIf="getShopLogo(selectedShopId); else defaultShopIcon" [src]="getShopLogo(selectedShopId)"
                  class="shop-icon me-2" alt="Shop Icon" />
                <ng-template #defaultShopIcon>
                  <img src="../../../assets/icons/user.svg" alt="Shop Icon" class="shop-icon me-2" />
                </ng-template>
                <span>{{ getShopName(selectedShopId) }}</span>
              </button>

              <ul class="dropdown-menu" aria-labelledby="shopDropdownButton">
                <li *ngFor="let shop of childShops">
                  <a class="dropdown-item d-flex align-items-center"
                    [ngClass]="{ 'active': selectedShopId === shop.shopId }" (click)="onChildShopChange(shop.shopId)">
                    <img *ngIf="shop.shopLogo; else defaultDropdownIcon" [src]="shop.shopLogo" class="shop-icon me-2"
                      alt="shop icon" />
                    <ng-template #defaultDropdownIcon>
                      <img src="../../../assets/icons/user.svg" alt="shop icon" class="shop-icon me-2" />
                    </ng-template>
                    <span>{{ shop.shopName }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </div>

        <div class="d-flex flex-row align-items-center">
          <li class="nav-item px-2">
            <div class="language-select-container">
              <app-translate></app-translate>
            </div>
          </li>
          <li class="nav-item px-2" *ngIf="permissions.config">
            <button class="nav-link bg-transparent border-0" (click)="openModal()" data-bs-toggle="tooltip"
              data-bs-placement="bottom" [attr.title]="('CONFIGURATION' | translate)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-settings">
                <circle cx="12" cy="12" r="3"></circle>
                <path
                  d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l-.06-.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z">
                </path>
              </svg>
            </button>
          </li>
          <li class="nav-item px-2">
            <button class="nav-link bg-transparent border-0" (click)="onSignOut()" data-bs-toggle="tooltip"
              data-bs-placement="bottom" [attr.title]="('LOG_OUT' | translate)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-log-out">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </button>
          </li>
        </div>
      </ul>
    </div>
  </div>
</nav>
